import SEAT_CHOICE_TYPES from '../../scripts/constants/seat-choice-types';
import regexMap from '../../scripts/constants/regex-map';
import SeatChoiceUIModel from './seat-choice';
import SeatChoiceUpsellUIModel from './seat-choice-upsell';
import SeatChoiceFareUpgradeUIModel from './seat-choice-fare-upgrade';

class PreselectSeatUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    seat = null,
    status = '',
    segmentCode = '',
  }) {
    this.code = seat && seat.code ? seat.code : '';
    this.seatChoiceClass = seat && seat._meta && seat._meta.class ? seat._meta.class : '';
    this.status = status;
    this.segmentCode = segmentCode;
    if (seat) {
      if (this.seatChoiceClass === SEAT_CHOICE_TYPES.SEAT_CHOICE) {
        this.choice = new SeatChoiceUIModel(seat);
      } else if (this.seatChoiceClass === SEAT_CHOICE_TYPES.SEAT_CHOICE_UPSELL) {
        this.choice = new SeatChoiceUpsellUIModel(seat);
      } else if (this.seatChoiceClass === SEAT_CHOICE_TYPES.SEAT_CHOICE_FARE_UPGRADE) {
        this.choice = new SeatChoiceFareUpgradeUIModel(seat);
      } else if (this.choice.isExitRowSeat) {
        return 'EXIT_ROW';
      }
    }
  }

  getSeatLabel() {
    if (!this.choice) return;

    return this.choice.getSeatLabel();
  }

  getSeatLetter() {
    return this.code.replace(regexMap.NON_ALPHA_CHARS, '');
  }

  getSeatTypeCopyID() {
    if (this.choice.isWindowSeat) {
      return 'SEATMAP_SEAT_TYPE_WINDOW';
    } else if (this.choice.isAisleSeat) {
      return 'SEATMAP_SEAT_TYPE_AISLE';
    } else if (this.choice.isMiddleSeat) {
      return 'SEATMAP_SEAT_TYPE_MIDDLE';
    } else if (this.choice.isExitRowSeat) {
      return 'EXIT_ROW';
    }
  }
}

export default PreselectSeatUIModel;
